import React from 'react';
import { withRouter } from 'react-router-dom';
import { Card, List, Checkbox, Popup, Dropdown, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Loader, Dimmer } from 'semantic-ui-react'


class PublicLibrarySetting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            publicAccess:props.selectedOrganisation.publicLibraryAccess,
            loader:false
        }
    }

    async onPublicLibraryToggle() {
        this.setState({loader:true},async()=>{
            await dispatch.organizationUnit.updateOrganization({ _id: this.props.selectedOrganisation.id, publicLibraryAccess: !this.state.publicAccess })
            this.setState({publicAccess:!this.state.publicAccess,loader:false})
            // Folllowing changes are made for KLM-8906
            await dispatch.app.setSelectedOrganisationData(this.props.selectedOrganisation)
        })
    }
    
    render() {
        return (
            <div className="general-setting">
                <Card>
                    <Card.Header>
                        Public Library Setting
                    </Card.Header>
                    <Card.Content className="pad_0">
                        <List divided verticalAlign='middle' >
                            <List.Item className="multiLine">
                                <List.Content >
                                    <List.Header style={{display:"inline"}}>
                                        Enable Public Library
                                    </List.Header>
                                    <List.Content style={{marginTop:"-2px"}} floated='right'>
                                        <Checkbox toggle
                                        checked={this.state.publicAccess}
                                        onChange={() => this.onPublicLibraryToggle()}
                                        />
                                    </List.Content>
                                    {this.props.selectedAccount.publicAccess && <div style = {{marginTop:"4px"}}>Since Public Access from admin is turned off, this toggle will only change access for viewing public libraries</div>}
                                </List.Content>
                            </List.Item>
                        </List>
                    </Card.Content>
                </Card>
                <Dimmer inverted active={this.state.loader} page={true}>
                    <Loader content={"please wait..."} size="large"/>
                </Dimmer>
            </div>
        );
    }
}

export default withRouter(PublicLibrarySetting);